<template>
    <el-popover
        placement="right"
        width="500"
        trigger="click"
        @show="remarkPopShow"
    >
        <el-table :data="tableData">
            <!-- Content、Operator、Date -->
            <el-table-column
                label="Content"
                property="remark"
                show-overflow-tooltip
                min-width="150"
            ></el-table-column>
            <el-table-column
                width="100"
                label="Operator"
                property="user_name"
            ></el-table-column>
            <el-table-column
                label="Date"
                property="create_time"
            ></el-table-column>
        </el-table>
        <el-button slot="reference" type="text" size="mini">{{
            item.name
        }}</el-button>
    </el-popover>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
export default {
    props: {
        item: Object,
        btnClassName: String,
        tableItem: Object,
    },
    data() {
        return {
            tableData: [],
        };
    },
    methods: {
        remarkPopShow() {
            cmofferApi.orderRemark({}, "get", this.item.rowId).then((res) => {
                if (res) {
                    console.log(res);
                    this.tableData = res.data;
                }
            });
        },
    },
};
</script>

<style lang="scss">
</style>>
